import { render } from "./TranslationList.vue?vue&type=template&id=56384012&scoped=true"
import script from "./TranslationList.vue?vue&type=script&lang=js"
export * from "./TranslationList.vue?vue&type=script&lang=js"

import "./TranslationList.vue?vue&type=style&index=0&id=56384012&scoped=true&lang=css"

import exportComponent from "/home/ysm/workspace/kft/translate/translate-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56384012"]])

export default __exports__